/**
 * Build a URL query string from an object of params, omitting any param whose
 * value is null, undefined, or an empty string. Arrays are comma-joined.
 *
 * @param {Object} params
 * @returns {string} the query string WITHOUT the leading "?" (e.g. "page=1&search=foo")
 */
export const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return;
    }
    searchParams.append(key, Array.isArray(value) ? value.join(",") : value);
  });
  return searchParams.toString();
};
